import { Typography } from '@mui/material';
import React from 'react';

const EconsultSettings = () => {
  return <Typography>Settings</Typography>;
};

export default EconsultSettings;
